import { COLOR } from 'utils/variables';
import {DocTypes} from 'myshubhlife-component/docInput';
export interface IFieldGroup {
  label: string;
  identifier: string;
  type?: string | DocTypes;
  errorMsg?: string;
  isRequired?: boolean;
  tooltipLabel?: string;
  validated?: Validated;
  url?: string;
  disabled?: boolean;
}

interface IInputFieldGroup extends IFieldGroup {
  value?: string | number;
  min?: string | number;
  max?: string | number;
  regex?: string;
  isReadOnly?: boolean;
}

interface IRadioButtonGroup extends IFieldGroup {
  value?: string | number;
  options?: IRadioButton[];
  activeColor?: COLOR;
  iconUrl?: string;
}

interface IDocFieldGroup extends IFieldGroup {
  secondaryLabel?: string;
  docBgColor?: string;
}

interface IDropdownGroup extends IFieldGroup {
  value?: string | number;
  options?: IOptions[];
}

interface IOtpFieldGroup extends IFieldGroup {
  value?: string[];
  otp?: string[];
  otpLength?: number;
  otpType?: string;
}

interface IDatePickerFieldGroup extends IFieldGroup {
  value?: string;
  min?: string;
  max?: string;
}

export type Validated = 'success' | 'warning' | 'error' | 'default';

interface IOptions {
  name: string;
  value: string | number;
}

interface IFormGroup {
  label: string;
  identifier: string;
  fields: IFieldGroup[];
}

export interface IFormFields {
  formfields: IFormGroup;
  formindex: number;
  handleFormChange: (index: number, value: string | number | string[] | boolean | object, formindex: number, fieldname: string, ) => void;
  selectStyleType?: string;
  inputStyleType?: string;
}

export interface IFormGroupProps {
  formData: IFormProps;
  onFormSubmit: any;
  onFormChange: (index: number, value: string | number | string[] | boolean | object, formindex: number, fieldname: string, ) => void;
}

interface IFormProps {
  label?: string;
  identifier?: string;
  fields: any;
  buttonlabel?: string;
  selectStyleType?: string;
  inputStyleType?: string;
}

interface IFormTypeGroup {
  component: string;
  label: string;
  identifier: string;
  type: string;
}

export interface IFormFieldGroup {
  component: string;
  label: string;
  identifier: string;
  fields: IFormTypeGroup[];
}
interface IFieldProps {
  index: number;
  handleFormChange: (value: string | number | string[] | boolean | object, index: number, identifier: string) => void;
  styleType?: string;
}

export interface IInputFieldProps extends IFieldProps {
  field: IInputFieldGroup;
}

export interface IRadioButtonProps extends IFieldProps {
  field: IRadioButtonGroup;
}

export interface IDocFieldProps extends IFieldProps {
  field: IDocFieldGroup;
}

export interface IDropdownProps extends IFieldProps {
  field: IDropdownGroup;
}
export interface IOtpProps extends IFieldProps {
  field: IOtpFieldGroup;
}
export interface IDatePickerProps extends IFieldProps {
  field: IDatePickerFieldGroup;
}
interface IRadioButton {
  name: string;
  value: string;
  fieldName: string;
  checked?: boolean;
  iconUrl?: string;
}

export enum SCOMP {
  TEXT = 'text',
  DATE = 'text',
  NUMBER = 'text',
  PINCODE = 'text',
  EMAIL = 'text',
  IFSC = 'text',
  RADIO = 'radioButton',
  FILE = 'file',
  DROPDOWN = 'dropdown',
  OTP = 'otp',
  DATEPICKER = "datePicker",
}
